module.exports = __webpack_public_path__ + "static/media/syrianbeef.b4f78b09.jpg";